import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MicrosoftBrandIconSvg = function MicrosoftBrandIconSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F35325",
    d: "M1.043 1.043h10.435v10.435H1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81BC06",
    d: "M12.522 1.043h10.435v10.435H12.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#05A6F0",
    d: "M1.043 12.522h10.435v10.435H1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA08",
    d: "M12.522 12.522h10.435v10.435H12.522z"
  }));
};
export var MicrosoftBrandIcon = function MicrosoftBrandIcon(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MicrosoftBrandIconSvg
  }));
};